import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/avatar.png";
import Tilt from "react-parallax-tilt";
import {
  AiFillGithub,
  AiFillInstagram,
} from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";

function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
              LET ME <span className="purple"> INTRODUCE </span> MYSELF
            </h1>
            <p className="home-about-body">
              I fell in love with IT and I know one or two things
              about it, I think… 🤷‍♂️
              <br />
              <br />I mainly worked in web development with 
              <i>
                <b className="purple"> TypeScript and Javascript. </b> 
              </i>
Although I mainly worked with web development, I am always open to expand my skill set.
              <br />
              <br />
              My fields of interest are all areas related to&nbsp;
              <i>
                <b className="purple">Web Technologies </b> 
                </i> as well as{" "}
                <i><b className="purple">
                  Game Development.
                </b></i>
              <br />
              <br />
              In my free time, I play bass guitar in a band and work on personal projects like my current game projects
              using <i><b className="purple">Unity and GameMaker, </b></i>
              with
              <i>
                <b className="purple">
                  {" "}
                  Unreal Engine 
                </b>
              </i>
              &nbsp;  up next.
            </p>
          </Col>
          <Col md={4} className="myAvtar">
            <Tilt>
              <img src={myImg} className="img-fluid" alt="avatar" />
            </Tilt>
          </Col>
        </Row>
        <Row>
          <Col md={12} className="home-about-social">
            <h1>FIND ME ON</h1>
            <ul className="home-about-social-links">
              <li className="social-icons">
                <a
                  href="https://github.com/ErayRonald"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiFillGithub />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.linkedin.com/in/erayozcan/"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <FaLinkedinIn />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.instagram.com/eray.rnd/"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <AiFillInstagram />
                </a>
              </li>
            </ul>
          </Col>
            <p md={12} className="home-about-social"> 
              Feel free to <span className="purple">connect </span>with me!
            </p>
        </Row>
      </Container>
    </Container>
  );
}
export default Home2;
